import Logo from '../assets/images/산림청로고.png';
import AuthHeader from '../components/AuthHeader';
import '../styles/css/jga_style.scss';
import '../styles/css/font.scss';
import React from 'react';
import { Link } from 'react-router-dom';

type Props = {
  title: string;
  rootPath: string;
  category: React.ReactNode;
  alarmComponent?: React.ReactNode;
  isAdmin: boolean;
  mainUrl: string;
  userName: string;
  logoutFunc: any;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
};
function HeaderTemplate({
  title,
  rootPath,
  category,
  alarmComponent,
  logoutFunc,
  isAdmin,
  userName,
  mainUrl,
  setModalOpen,
}: Props) {
  return (
    <header className="header">
      <div className="hLogo">
        <a href={mainUrl}>
          <img src={Logo} />
        </a>

        <span>
          <Link to='/'>{title}</Link>
        </span>
      </div>

      <nav className="nav">
        <ul className="nMenuList">{category}</ul>
      </nav>
      <AuthHeader
        userName={userName}
        rootPath={rootPath}
        isAdmin={isAdmin}
        alarmComponent={alarmComponent}
        logoutFunc={logoutFunc}
        setModalOpen={setModalOpen}
      />
    </header>
  );
}

export default HeaderTemplate;
